/* SET STATE */
export const SET_STATE_KIND = "SET_STATE_KIND"

/* KINDS */
export const GET_KINDS = "GET_KINDS"
export const GET_KINDS_SUCCESS = "GET_KINDS_SUCCESS"
export const GET_KINDS_FAIL = "GET_KINDS_FAIL"

/* KIND */
export const GET_KIND = "GET_KIND"
export const GET_KIND_SUCCESS = "GET_KIND_SUCCESS"
export const GET_KIND_FAIL = "GET_KIND_FAIL"

/**
 * ADD KIND
 */
 export const ADD_NEW_KIND = "ADD_NEW_KIND"
 export const ADD_KIND_SUCCESS = "ADD_KIND_SUCCESS"
 export const ADD_KIND_FAIL = "ADD_KIND_FAIL"

 /**
 * UPDATE KIND
 */
export const UPDATE_KIND = "UPDATE_KIND"
export const UPDATE_KIND_STATUS = "UPDATE_KIND_STATUS"
export const UPDATE_KIND_SUCCESS = "UPDATE_KIND_SUCCESS"
export const UPDATE_KIND_FAIL = "UPDATE_KIND_FAIL"

/**
 * DELETE KIND
 */
export const DELETE_KIND = "DELETE_KIND"
export const DELETE_KIND_SUCCESS = "DELETE_KIND_SUCCESS"
export const DELETE_KIND_FAIL = "DELETE_KIND_FAIL"
